export default {"src":"/planos/_next/static/media/equifax-building-search.d9937efd.svg","height":27,"width":28,"blurWidth":0,"blurHeight":0};